<!-- 測定結果レポート本体(OF-5チェック結果なし) -->
<template>
  <div class="report-no-of">
    <!-- タイトル -->
    <div class="report-title">
      <div class="report-title-detail">
        <div class="report-title-detail-left"></div>
      </div>
    </div>

    <!-- グラフ -->
    <div class="report-graph" :class="!isAnalysisFlag?' mt-16':'mt-29'">
      <div  v-for="measure in measurements" :key="measure.type">
        <div class="report-graph-column"
        :class="[`report-graph-column--${vocabCounts[measure.type] == null ? 'none' : measure.type}`,
        isAnalysisFlag?'report-graph-column--analaysis':'']">
          <template v-if="!isAnalysisFlag">
            <div class="report-graph-column-audio"
            :class="vocabCounts[measure.type] == null?`report-graph-column-audio--${measure.type}`:''">
              <div class="audio-icon" :class="vocabCounts[measure.type] == null?`audio-icon--${measure.type}`:''"></div>
              <div class="audio-text">{{ $t('report.pronunciation_count') }}</div>
            </div>
          </template>
          <template v-else>
            <div class="report-graph-column-audio report-graph-column-audio--analaysis"
            :class="vocabCounts[measure.type] == null?`report-graph-column-audio--${measure.type}`:''">
              <div class="audio-icon audo-icon--analaysis" :class="vocabCounts[measure.type] == null?`audio-icon--${measure.type}`:''"></div>
              <div class="audio-text audio-text--analaysis">{{ $t('report.count_and_clarity') }}</div>
            </div>
          </template>

          <template v-if="!isAnalysisFlag">
            <div class="report-graph-column-top">
              <div class="top-title mt-4">{{ $t('report.performance') }}</div>
              <div class="top-status">
                <div class="top-status-colum">
                  <template v-if="vocabCounts[measure.type] == null">
                    <div class="top-status-star-colum top-status-star-colum--none"></div>
                    <div class="top-status-none-colum">{{ $t('test_list.status_not_tested') }}</div>
                  </template>
                  <template v-if="vocabCounts[measure.type] != null">
                    <div class="top-status-star-colum"
                    :class="[`top-status-star-colum--${vocabPerSeconds[measure.type] >= 6.0?'good':vocabPerSeconds[measure.type] >= 4.0?'sortgood':'bad'}-${measure.type}`]"></div>
                    <div class="top-status-face-colum">
                      <div class="face"
                      :class="[`${vocabPerSeconds[measure.type] >= 6.0?'good':vocabPerSeconds[measure.type] >= 4.0?'sortgood':'bad'}-face--${measure.type}`]"></div>
                      <div>{{vocabPerSeconds[measure.type] >= 6.0?$t('report.feedback_excellent'):vocabPerSeconds[measure.type] >= 4.0?$t('report.feedback_almost_there'):$t('report.feedback_keep_trying')}}</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="report-graph-analaysis-top"  :class="[`report-graph-analaysis-top--${vocabCounts[measure.type] == null ? 'none' : measure.type}`]">
              <div class="top-column top-column--left">
                <div class="top-column-text">{{ $t('report.total_count') }}</div>
                <div class="top-column-score" :class="vocabCounts[measure.type] != null ? 'top-column-score--on':'-'">
                  <span class="top-column-score-big">{{vocabCounts[measure.type] != null ? vocabCounts[measure.type]:'-'}}</span>
                  <span v-show="vocabCounts[measure.type] != null">{{ $t('test_list.times') }}</span>
                </div>
              </div>
              <div class="top-column top-column--right">
                <div class="top-column-text">{{ $t('report.clear_count_prefix') }}{{measure.type == 'pa'?$t('test_list.patk_label_pa'):measure.type == 'ta'?$t('test_list.patk_label_ta'):$t('test_list.patk_label_ka')}}<span v-html="$t('report.clear_count_suffix')"></span></div>
                <div class="top-column-score" :class="analysisVocabCounts[measure.type] != null ?  'top-column-score--on':''">
                  <span class="top-column-score-big">{{analysisVocabCounts[measure.type] != null ? analysisVocabCounts[measure.type]:'-'}}</span>
                  <span v-show="analysisVocabCounts[measure.type] != null">{{ $t('test_list.times') }}</span>
                </div>
              </div>
              <div class="pie-charts">
                <div class="pie-charts-colum">
                  <div v-if="vocabCounts[measure.type] != null" class="buttom" :style="buttom(measure.type)"></div>
                  <div v-else class="buttom" :style="buttom()"></div>
                  <div v-if="vocabCounts[measure.type] != null" class="center" :style="center(measure.type)"></div>
                  <div v-else class="center" :style="center()"></div>
                  <div v-if="vocabCounts[measure.type] != null" class="top">
                    <div class="top-text">{{analysisVocabCounts[measure.type]  != null ? graphPercent[measure.type]:'-'}}</div>
                    <div class="buttom-text">%</div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="report-graph-column-main">
            <div class="top-wrap">
              <div class="top-wrap-left">
                <div class="title">{{ $t('report.count_per_second') }}</div>
                <canvas
                  :ref="`graphCanvas-${measure.type}`"
                  :id="`graphCanvas-${measure.type}`"
                  style="width: 157px; height: 106px;"
                  class="graph"
                  :class="(measure.measurementType == '1' || (!measure.measurementType && measurementType == '1')) ? 'graph--five' : ''">
                </canvas>
              </div>
              <div class="bottom-wrap-right" :class="[`bottom-wrap-right--${measure.type}`]">
                <div class="title" :class="!isAnalysisFlag?' mt-13':'mt-18'">{{ $t('report.per_second') }}</div>

                <div v-if="vocabCounts[measure.type] == null" class="per per--none">-</div>
                <div v-else class="per" :class="!isAnalysisFlag?'per--seconds-normal':'per--seconds-analaysis'">
                  {{ $t('report.average_times_per_sec_prefix') }}<span :class="!isAnalysisFlag?'per-seconds-big':'per-seconds-analaysis'">{{ vocabPerSeconds[measure.type] }}</span>{{ $t('report.average_times_per_sec_suffix') }}
                </div>

                <template v-if="!isAnalysisFlag">
                  <div class="title mt-8">{{ $t('report.total_count') }}</div>
                  <div v-if="vocabCounts[measure.type] == null" class="per per--none">-</div>
                  <div v-else class="per per--counts"><span class="per-counts-big">{{vocabCounts[measure.type]}}</span>{{ $t('test_list.times') }}</div>
                </template>
                <template v-else>
                  <div class="analysis-explanation mt-9">
                    <div class="icon" :class="[`icon--${measure.type}`]"></div>
                    <div class="text">{{ $t('report.pronunciation_count') }}</div>
                  </div>
                  <div class="analysis-explanation mt-3">
                    <div class="icon"></div>
                    <div class="text">
                      {{ $t('report.clear_count_prefix') }}{{measure.type == 'pa'?$t('test_list.patk_label_pa'):measure.type == 'ta'?$t('test_list.patk_label_ta'):$t('test_list.patk_label_ka')}}<span v-html="$t('report.clear_count_suffix')"></span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="text-wrap" :class="!isAnalysisFlag?' mt-6':''">{{ $t('report.target_text_prefix') }}{{(measure.measurementType=='1' || (!measure.measurementType && measurementType=='1')) ? '30':'60'}}{{$t('report.target_text_suffix') }}</div>
            <div class="border-wrap" :class="!isAnalysisFlag? 'mt-11':'mt-5'"></div>
            <div class="bottom-wrap" style="margin-top: 15px; margin-bottom: 15px;">
              <div class="bottom-wrap-inner" v-if="measure.type == 'pa'">
                <div class="mt-3">{{ $t('report.lip_motion') }}</div>
                <div class="bottom-wrap-text" :class="[`bottom-wrap-text--${measure.type}`]" v-html="$t('report.lip_motion_desc')">
                </div>
              </div>
              <div v-else-if="measure.type == 'ta'">
                <div class="mt-3">{{ $t('report.anterior_tongue_motion') }}</div>
                <div class="bottom-wrap-text" :class="[`bottom-wrap-text--${measure.type}`]" v-html="$t('report.anterior_tongue_motion_desc')">
                </div>
              </div>
              <div v-else-if="measure.type == 'ka'">
                <div class="mt-3">{{ $t('report.posterior_tongue_motion') }}</div>
                <div class="bottom-wrap-text" :class="[`bottom-wrap-text--${measure.type}`]" v-html="$t('report.posterior_tongue_motion_desc')">
                </div>
              </div>
              <div class="bottom-wrap-img" :class="[`bottom-wrap-img--${measure.type}`]"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 凡例・注釈(グラフの下・右寄せ) -->
    <div class="report-note">
      <div v-if="!isAnalysisFlag" class="report-note-legend">
        <div class="">{{ $t('report.count_per_second_short') }}</div>
        <div class="ml-8 report-face report-face--good"></div>
        <div class="ml-4">{{ $t('report.threshold_6_or_more') }}</div>
        <div class="ml-8 report-face report-face--sort-good"></div>
        <div class="ml-4">{{ $t('report.threshold_4_to_5') }}</div>
        <div class="ml-8 report-face report-face--bad"></div>
        <div class="ml-4">{{ $t('report.threshold_less_than_4') }}</div>
      </div>
      <div v-else>{{ $t('report.with_clarity_note') }}</div>
    </div>

    <!-- 下部情報 -->
    <div class="report-bottom">
      <div class="report-bottom-center"></div>
      <div class="report-bottom-text">
        <div class="report-bottom-date">{{ inspectionTimeText }}</div>
        <div class="report-bottom-copyright">© 2025 Lion Corporation. All rights reserved.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { buttom as pieButtom, center as pieCenter } from './common/pieChart';

export default {
  props: {
    isAnalysisFlag: { type: Boolean, default: false },
    measurements: { type: Array, default: () => [] },
    vocabPerSeconds: { type: Object, default: () => ({}) },
    vocabCounts: { type: Object, default: () => ({}) },
    analysisVocabCounts: { type: Object, default: () => ({}) },
    graphPercent: { type: Object, default: () => ({}) },
    measurementType: { type: String, default: null },
    inspectionTimeText: { type: String, default: '' },
  },
  setup(props) {
    const buttom = (measureWord) => pieButtom(props.graphPercent, measureWord);
    const center = (measureWord) => pieCenter(props.graphPercent, measureWord);

    return {
      buttom,
      center,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/style.scss';

// OF-5ボックス無しレイアウト。
// scopedのため、以下の指定は当コンポーネントの要素にのみ適用され、
// 共通クラス名を使っていてもMeasureResultBodyWithOf.vueには影響しない。
// (セレクタは共通スタイルと詳細度を揃えるため .report 配下にネストする)
.report {
  // flexコンテナにしてマージンの相殺を止める。
  // blockのままだと .report-title の上マージンは .report-line の下マージン(12px)と、
  // 下マージンは .report-graph の mt-16/mt-29 と相殺して指定値が効かない。
  // (フッターはposition:absoluteでflexアイテムにならないため影響を受けない)
  .report-no-of {
    display: flex;
    flex-direction: column;
  }

  // タイトルは中央寄せ・大きめ
  .report-title {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .report-title-detail {
    justify-content: center;
  }

  .report-title-detail-left {
    width: 310px;
    height: 21px;
    background-size: 310px 21px;
  }

  // 凡例・注釈はグラフの下に右寄せで置く
  .report-note {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    font-family: "NotoSans-Medium";
    font-size: 9px;
    color: #000;
  }

  .report-note-legend {
    display: flex;
    align-items: center;
  }

  // フッターはロゴを中央、日時を左端、コピーライトを中央に置く。
  // ヘッダーやグラフの高さは画面と印刷(用紙600px/幅1100px)で変わるため、
  // 流し込みでの下寄せではなく .report のパディングボックス基準で下端に固定する。
  .report-bottom {
    position: absolute;
    left: 32px;   // .report の padding-left
    right: 32px;  // .report の padding-right
    bottom: 28px; // .report の padding-bottom
    width: auto;  // 共通スタイルのwidth:100%を解除し、left/rightで幅を決める
    display: block;
  }

  // 左右autoのみ指定し、共通スタイルのmargin-top(画面14px/印刷17px)は残す
  .report-bottom-center {
    margin-left: auto;
    margin-right: auto;
  }

  .report-bottom-text {
    position: relative;
    display: flex;
    justify-content: center;
    font-family: "NotoSans-Medium";
    font-size: 6px;
    line-height: 2.33;
    color: #666;
  }

  .report-bottom-date {
    position: absolute;
    left: 0;
  }
}

// 印刷時は共通スタイルが各要素を拡大するため、追加した要素も同じ比率で合わせる
@media print {
  .report {
    .report-title-detail-left {
      width: 371px;
      height: 25px;
      background-size: 371px 25px;
    }

    .report-note {
      font-size: 10px;
    }

    .report-bottom-text {
      font-size: 7px;
    }
  }
}

// PC印刷では各要素が拡大され、内容は .report(高さ600px)の下端を超えて流し込まれる。
// OF-5あり版のフッターも用紙上端から734px(= .report下端 + 94px)に来るため、
// 同じ位置に合わせる。これをしないとフッターが上に寄り、注釈と重なる。
@media print and (min-width: 601px) {
  .report .report-bottom {
    bottom: -94px;
  }
}
</style>
